import { render } from "./VotingSystems.vue?vue&type=template&id=25a5c031&ts=true"
import script from "./VotingSystems.vue?vue&type=script&lang=ts"
export * from "./VotingSystems.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__